
export const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;


/** 

Breakdown of the Regular Expression
^ and $: These denote the start and end of the string, ensuring that the entire string is matched against the regex pattern.
(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?): This part of the regex matches a single octet of the IPv4 address. Each IPv4 address consists of four octets separated by dots. The pattern within the parentheses handles the possible values for each octet:
25[0-5]: Matches numbers from 250 to 255.
2[0-4][0-9]: Matches numbers from 200 to 249.
[01]?[0-9][0-9]?: Matches numbers from 0 to 199. This part allows:
[01]?: An optional leading 0 or 1, allowing for single or double-digit numbers.
[0-9][0-9]?: Matches the remaining digits, ensuring it covers 0-99.
\.: This matches the dot (.) character separating the octets.
(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\. repeated three times: This pattern is repeated three times to account for the first three octets of the IPv4 address.
(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?): This final part matches the fourth octet.

Example Matches

Valid IPv4 addresses:
192.168.1.1
255.255.255.255
0.0.0.0
127.0.0.1
172.16.254.1

Invalid IPv4 addresses:
256.256.256.256 (octets out of range)
192.168.1 (missing octet)
192.168.1.256 (last octet out of range)
192.168.1.-1 (negative number)

This regex ensures that the input string conforms to the format of a valid IPv4 address, where each octet ranges from 0 to 255 and the octets are separated by dots.

**/